<template>
  <div class="row q-pa-md items-center">
    <div style="display: inline-block" class="text-h6">
      <q-btn @click="$emit('close')" flat>
        <q-icon name="mdi-arrow-left"> </q-icon>
      </q-btn>
      Marshall
    </div>
    <q-btn
      class="q-ml-md q-px-xs"
      color="secondaryButton"
      text-color="accent"
      no-caps
      unelevated
      dense
      @click="addMember"
      :disable="!event"
    >
      <q-icon size="xs" name="mdi-plus-circle"></q-icon>
    </q-btn>
    <q-btn
      class="q-ml-md q-px-xs"
      color="secondaryButton"
      text-color="accent"
      no-caps
      unelevated
      @click="$store.dispatch('settings/toggleVirtualScrolling')"
      dense
      v-if="$q.screen.gt.xs"
    >
      <q-icon size="xs" name="mdi-printer"></q-icon>
    </q-btn>

    <q-btn
      class="q-ml-md q-px-xs"
      color="secondaryButton"
      text-color="accent"
      no-caps
      unelevated
      @click="startScanner"
      dense
    >
      <q-icon size="xs" name="mdi-nfc-variant"></q-icon>
    </q-btn>
    <q-btn
      class="q-ml-md q-px-xs"
      color="secondaryButton"
      text-color="accent"
      no-caps
      unelevated
      @click="marshallAll"
      dense
      :loading="markAllLoading"
    >
      <q-icon size="xs" name="mdi-check" class="q-mr-sm"></q-icon>
      Mark all
    </q-btn>
    <q-space />
    <!-- <q-input
      style="max-width: 70%"
      filled
      v-model="rfid"
      debounce="200"
      label="Scan RFID"
      clearable
      dense
    >
      <template #prepend>
        <q-icon name="mdi-magnify"> </q-icon>
      </template>
    </q-input> -->
    <!-- <q-btn icon="mdi-close" flat @click="$emit('close')"> </q-btn> -->
    <div
      class="col-12 mt-0 pt-0"
      :style="
        `${
          !disableVirtualScrolling
            ? 'height: calc(100vh - 280px) !important'
            : ''
        }`
      "
    >
      <div
        v-if="disableVirtualScrolling"
        style="width: 100%;
    height: 100%; z-index: 9999999; opacity: 0; background-color: black; position: absolute;"
      ></div>
      <datatable
        :filter="search"
        :flat="true"
        :data="round.marshalled"
        :columns="columns"
        @rowDoubleClick="handleDoubleClick"
        :hidePagination="true"
      >
        <template slot="body-cell-id" slot-scope="data">
          <q-td :props="data.props">
            <div class="row items-center">
              <q-checkbox
                v-model="data.props.row.status"
                :true-value="1"
                :false-value="0"
                dense
                @input="updateValue(data.props.row.id, data.props.row.status)"
                v-if="data.props.row.scratched != 1"
              ></q-checkbox>
              <q-icon
                v-if="data.props.row.scratched == 1"
                name="mdi-close"
                color="negative"
                size="20px"
              ></q-icon>
              <q-btn dense round flat class="float-right" color="black">
                <q-icon name="mdi-dots-vertical"></q-icon>
                <q-menu>
                  <q-list style="min-width: 100px">
                    <q-item
                      @click="scratch(data.props.row)"
                      clickable
                      v-close-popup
                    >
                      <q-item-section>Scratch/Unscratch</q-item-section>
                    </q-item>
                    <q-separator v-if="data.props.row.team_name" />
                    <q-item
                      v-if="data.props.row.team_name"
                      clickable
                      @click="
                        currentTeamDetails = data.props.row;
                        teamDetailsModel = true;
                      "
                      v-close-popup
                    >
                      <q-item-section>Manage Reserves</q-item-section>
                    </q-item>
                  </q-list>
                </q-menu>
              </q-btn>
            </div>
          </q-td>
        </template>
        <template slot="body-cell-capUrl" slot-scope="data">
          <q-td :props="data.props">
            <q-img
              v-if="data.props.row.capUrl"
              :src="data.props.row.capUrl"
              style="width: 40px"
              contain
            >
            </q-img>
            <q-img
              v-else
              src="https://nzsls.s3.ap-southeast-2.amazonaws.com/associationAssets/Composite+Teams+Cap.png"
              style="width: 40px"
              contain
            >
            </q-img>
          </q-td>
        </template>
        <template slot="body-cell-firstName" slot-scope="data">
          <q-td
            style="
              min-width: 350px;
              max-width: 350px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              line-height: 14px
            "
            v-if="!data.props.row.team_name"
            :props="data.props"
            :style="
              `${
                data.props.row.scratched ? 'text-decoration: line-through;' : ''
              };`
            "
          >
            {{ data.props.row.firstName }} {{ data.props.row.lastName }}
            <q-icon
              v-if="data.props.row.rfid"
              color="blue-grey"
              size="xs"
              name="mdi-tag-text"
            >
              <q-tooltip>RFID - {{ data.props.row.rfid }}</q-tooltip>
            </q-icon>
            <br />
            <span style="font-size: 10px">
              {{
                data.props.row.association_abbr
                  ? data.props.row.association_abbr
                  : "Composite"
              }}
            </span>
          </q-td>
          <q-td
            style="
              min-width: 350px;
              max-width: 350px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              line-height: 14px
            "
            :style="
              `${
                data.props.row.scratched ? 'text-decoration: line-through;' : ''
              }; `
            "
            v-else
          >
            <b>{{ data.props.row.team_name }}</b> <br />
            <span
              style="font-size: 10px"
              v-for="(member, index) in data.props.row.members"
              :key="`member_${index}`"
            >
              {{ member.firstName }} {{ member.lastName }}
              {{ index < data.props.row.members.length - 1 ? ", " : "" }} </span
            ><br />
            <span style="font-size: 10px; font-weight: bold;">
              {{
                data.props.row.association_abbr
                  ? data.props.row.association_abbr
                  : "Composite"
              }}
            </span>
          </q-td>
        </template>
        <template slot="body-cell-race_id" slot-scope="data">
          <q-td :props="data.props">
            <span
              @click="
                currentTeamDetails = data.props.row;
                changeWaveDialog = true;
              "
            >
              {{
                data.props.row.race_index !== null
                  ? data.props.row.race_index + 1
                  : "Please Select (Click me)"
              }}
            </span>
          </q-td>
        </template>
        <template slot="body-cell-lane_no" slot-scope="data">
          <q-td :props="data.props">
            <span
              @click="
                currentTeamDetails = data.props.row;
                changeLaneDialog = true;
              "
            >
              {{ data.props.row.lane_no }}
            </span>
          </q-td>
        </template>
      </datatable>
    </div>
    <div class="col-12 q-mt-sm" style="margin-top: 9px; z-index: 2">
      <q-btn color="blue-grey q-mr-sm" @click="$emit('close')" no-caps
        >Close</q-btn
      >
      <q-btn
        label="Reset"
        no-caps
        color="blue-grey"
        @click="resetMarshalling()"
        :loading="resetting"
      ></q-btn>
      <q-btn
        color="primary"
        :loading="publishLoading"
        @click="publish()"
        class="float-right"
        no-caps
        >Publish</q-btn
      >
    </div>
    <q-dialog v-model="teamDetailsModel">
      <teamDetailsCard :team="currentTeamDetails" :round="round" marshall />
    </q-dialog>
    <q-dialog v-model="changeWaveDialog">
      <q-card v-if="changeWaveDialog" style="width: 300px">
        <q-card-section>
          <div class="text-h6">Changing Wave</div>
          <div class="text-subtitle2">
            {{ currentTeamDetails.team_name }}
          </div>
        </q-card-section>
        <q-separator></q-separator>
        <q-card-section>
          <div class="row">
            <div class="col-12">
              <q-select
                v-model="currentTeamDetails.race_id"
                :options="racesForRound"
                option-label="race_index"
                option-value="id"
                map-options
                emit-value
                label="Wave"
                v-bind="siteCFG.fields.general"
              >
              </q-select>
            </div>
          </div>
        </q-card-section>
        <q-card-section align="right">
          <q-btn
            label="Cancel"
            no-caps
            color="blue-grey"
            class="float-left"
            @click="
              changeWaveDialog = false;
              currentTeamDetails = {};
            "
          ></q-btn>
          <q-btn
            label="Submit"
            no-caps
            color="primary"
            @click="updateTeamRace"
            :loading="updatingTeamRace"
          ></q-btn>
        </q-card-section>
      </q-card>
    </q-dialog>
    <q-dialog v-model="changeLaneDialog">
      <q-card v-if="changeLaneDialog" style="width: 300px">
        <q-card-section>
          <div class="text-h6">Changing Lane</div>
          <div class="text-subtitle2">
            <!-- TODO: Update to work for Individuals -->
            {{ currentTeamDetails.team_name }}
          </div>
        </q-card-section>
        <q-separator></q-separator>
        <q-card-section>
          <div class="row">
            <div class="col-12">
              <q-input
                v-model="currentTeamDetails.lane_no"
                label="Lane No."
                v-bind="siteCFG.fields.general"
              >
              </q-input>
            </div>
          </div>
        </q-card-section>
        <q-card-section align="right">
          <q-btn
            label="Cancel"
            no-caps
            color="blue-grey"
            class="float-left"
            @click="
              changeLaneDialog = false;
              currentTeamDetails = {};
            "
          ></q-btn>

          <q-btn
            label="Submit"
            no-caps
            color="primary"
            @click="updateTeamLane"
            :loading="updatingTeamLane"
          ></q-btn>
        </q-card-section>
      </q-card>
    </q-dialog>
    <q-dialog
      v-model="addTeamDialog"
      :maximized="$q.screen.lt.sm"
      persistent
      max-width="90vw"
    >
      <q-card v-if="addTeamDialog" tile style="width: 90vw; max-width: 90vw">
        <q-card-section class="q-pa-sm q-pl-md">
          <div class="row items-center">
            <q-btn
              round
              flat
              icon="mdi-close"
              @click="
                addTeamDialog = false;
                loadData();
              "
            >
            </q-btn>
          </div>
        </q-card-section>
        <q-separator />
        <q-card-section>
          <teamEntryForm
            :id="$route.params.events_id"
            fromWaves
            :round_id="round.id"
            @close="
              addTeamDialog = false;
              loadData();
            "
            @newTeamEntered="
              $store.dispatch('eventProgress/loadCurrentRound', round.id)
            "
          />
        </q-card-section>
      </q-card>
    </q-dialog>
    <q-dialog
      v-model="addMemberDialog"
      :maximized="$q.screen.lt.sm"
      persistent
      max-width="90vw"
    >
      <q-card v-if="addMemberDialog" tile style="width: 90vw; max-width: 90vw">
        <q-card-section class="q-pa-sm q-pl-md">
          <div class="row items-center">
            <q-btn
              round
              flat
              icon="mdi-arrow-left"
              @click="
                addMemberDialog = false;
                loadData();
              "
            >
            </q-btn>
            <h3 style="font-size: 20px" class="q-my-none">
              {{ event.event_name }}
            </h3>
          </div>
        </q-card-section>
        <q-separator />
        <q-card-section>
          <individualEntryForm
            :id="$route.params.events_id"
            fromWaves
            :events_id="$route.params.events_id"
            :round_id="round.id"
            @close="
              addMemberDialog = false;
              loadData();
            "
            @newTeamEntered="
              $store.dispatch('eventProgress/loadCurrentRound', round.id)
            "
          />
        </q-card-section>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import datatable from "@/components/datatable/datatable.vue";
// import { Notify } from "quasar";
import teamDetailsCard from "@/components/wavesProgress/teamDetailsCard.vue";
import teamEntryForm from "@/components/competitions/teamEntryForm.vue";
import individualEntryForm from "@/components/competitions/individualEntryForm.vue";

export default {
  components: {
    datatable,
    teamDetailsCard,
    teamEntryForm,
    individualEntryForm
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
      siteCFG: "settings/siteCFG",
      event: "events/current",
      competition: "competitions/current",
      disableVirtualScrolling: "settings/disableVirtualScrolling"
    }),
    columns: function() {
      return [
        {
          name: "id",
          label: "",
          align: "left",
          field: "id",
          style:
            "min-width: 90px;max-width: 90px; width: 90px;white-space: nowrap;overflow: hidden;",
          hide: this.disableVirtualScrolling
        },
        {
          name: "capUrl",
          label: "Club",
          align: "left",
          field: "capUrl",
          style:
            "min-width: 80px;max-width: 80px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          hide: this.disableVirtualScrolling,
          sortable: true
        },
        {
          name: "firstName",
          label: "Name",
          align: "left",
          field: "firstName",
          style: `min-width: ${
            this.disableVirtualScrolling ? "150px" : "250px"
          };max-width: ${
            this.disableVirtualScrolling ? "150px" : "250px"
          };white-space: nowrap;overflow: hidden;text-overflow: ellipsis;`,
          sortable: true
        },
        {
          name: "race_id",
          label: "Wv.",
          align: "left",
          field: "race_id",
          style: `min-width: ${
            this.disableVirtualScrolling ? "60px" : "50px"
          };max-width: ${
            this.disableVirtualScrolling ? "60px" : "50px"
          };width: ${
            this.disableVirtualScrolling ? "60px" : "50px"
          };white-space: nowrap;overflow: hidden;text-overflow: ellipsis;`,
          sortable: true
        },
        {
          name: "qualMark",
          label: "Qual Time",
          align: "left",
          field: "qualMark",
          style: `min-width: ${
            this.disableVirtualScrolling ? "60px" : "90px"
          };max-width: ${
            this.disableVirtualScrolling ? "60px" : "90px"
          };width: ${
            this.disableVirtualScrolling ? "60px" : "90px"
          };white-space: nowrap;overflow: hidden;text-overflow: ellipsis;`,
          hide: this.competition.lane_order_type != "Centre Lane Out",
          sortable: true
        },
        {
          name: "lane_no",
          label: "Ln.",
          align: "left",
          field: "lane_no",
          style:
            "min-width: 50px;max-width: 50px;width: 50px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true
        },
        {
          name: "event_name",
          label: "Event",
          align: "left",
          field: "event_name",
          style:
            "min-width: 250px;max-width: 250px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          hide:
            !this.event.combinedEvents ||
            this.event.combinedEvents.length < 1 ||
            this.disableVirtualScrolling,

          sortable: true
        }
      ];
    }
  },
  props: {
    round: {
      default: null
    },
    raceIndex: {
      default: 0
    }
  },
  data: () => ({
    rfid: "",
    search: "",

    // Grid

    publishLoading: false,
    markAllLoading: false,

    teamDetailsModel: false,
    currentTeamDetails: {},

    // Change Wave
    changeWaveDialog: false,
    racesForRound: [],
    updatingTeamRace: false,

    // Change Lane
    changeLaneDialog: false,
    updatingTeamLane: false,

    // Reset to Marshalling
    resetting: false,

    // Add Team
    addTeamDialog: false,
    addMemberDialog: false
  }),
  watch: {
    race: function() {
      this.init();
    },
    round: function() {
      this.init();
      if (this.currentTeamDetails) {
        this.currentTeamDetails = this.round.marshalled.find(
          l => l.id == this.currentTeamDetails.id
        );
      }
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      // Getting the races for the current round
      this.racesForRound = [];
      if (this.round && this.round.races) {
        this.round.races.forEach(race => {
          this.racesForRound.push({
            id: race.id,
            race_index: race.race_index + 1
          });
        });
      }
    },
    loadData() {
      this.$store.dispatch("eventProgress/loadCurrentRound", this.round.id);
      this.$store.dispatch(
        "competitions/updateOmega",
        this.$route.params.competitions_id
      );
    },
    handleDoubleClick(row) {},
    addMember() {
      if (JSON.parse(this.event.playerLabels).length < 2) {
        this.addMemberDialog = true;
      } else {
        this.addTeamDialog = true;
      }
    },
    updateValue(id, status) {
      this.$store
        .dispatch("events/updateMarshalledStatus", {
          id: id,
          status: status
        })
        .then(result => {
          if (result.Result == "Success") {
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message
            });
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later"
            });
          }
        });
    },
    async publish() {
      this.publishLoading = true;

      let unMarshalledMembers = [];
      this.round.marshalled.forEach(p => {
        if (!p.status && !p.scratched) {
          unMarshalledMembers.push(p);
        }
      });

      if (unMarshalledMembers.length) {
        let res = await this.$swal({
          title: "Warning",
          text: `There are ${unMarshalledMembers.length} athletes/teams not marshalled. Continuing will scratch those members, did you want to continue?`,
          type: "warning",
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel",
          showCancelButton: true,
          confirmButtonColor: "#f58122"
        });
        if (res.value) {
          unMarshalledMembers.forEach(p => {
            this.scratch(p);
          });
        }
      }

      try {
        let result = await this.$store.dispatch("events/publishMarshalled", {
          id: this.round.races[this.raceIndex].id
        });

        this.publishLoading = false;
        if (result.Result == "Success") {
          this.round.races[this.raceIndex].marshalled = 1;
          this.$store.dispatch("eventProgress/loadCurrentRound", this.round.id);
          this.$store.dispatch(
            "competitions/updateOmega",
            this.$route.params.competitions_id
          );

          this.$q.notify({
            position: "top-right",
            type: "positive",
            message: result.Response.Message
          });
          this.$emit("close");
        } else {
          this.$q.notify({
            position: "top-right",
            type: "negative",
            message: "There was an Error, Please try again later"
          });
        }
      } catch (error) {
        this.$q.notify({
          position: "top-right",
          type: "negative",
          message: "There was an Error, Please try again later"
        });
      }
    },
    marshallAll() {
      this.markAllLoading = true;
      let notMarshalled = this.round.marshalled.filter(p => {
        return !p.status && p.scratched == 0;
      });
      this.$store
        .dispatch("events/marshallAll", {
          id: this.round.id,
          value: notMarshalled.length > 0 ? 1 : 0,
          isTeamEvent: JSON.parse(this.event.playerLabels).length > 1
        })
        .then(result => {
          this.markAllLoading = false;
          if (result.Result == "Success") {
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message
            });
            this.$store.dispatch(
              "eventProgress/loadCurrentRound",
              this.round.id
            );
            this.$store.dispatch(
              "competitions/updateOmega",
              this.$route.params.competitions_id
            );
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later"
            });
          }
        });
    },
    updateTeamRace() {
      this.updatingTeamRace = true;
      this.$store
        .dispatch("events/updateTeamRace", {
          lane_id: this.currentTeamDetails.lane_id,
          race_id: this.currentTeamDetails.race_id
        })
        .then(result => {
          this.updatingTeamRace = false;
          if (result.Result == "Success") {
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message
            });
            this.$store.dispatch(
              "eventProgress/loadCurrentRound",
              this.round.id
            );
            this.$store.dispatch(
              "competitions/updateOmega",
              this.$route.params.competitions_id
            );

            this.changeWaveDialog = false;
            this.currentTeamDetails = {};
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later"
            });
          }
        });
    },
    updateTeamLane() {
      this.updatingTeamLane = true;
      this.$store
        .dispatch("events/updateTeamLane", {
          lane_id: this.currentTeamDetails.lane_id,
          lane_no: this.currentTeamDetails.lane_no
        })
        .then(result => {
          this.updatingTeamLane = false;
          if (result.Result == "Success") {
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message
            });
            this.$store.dispatch(
              "eventProgress/loadCurrentRound",
              this.round.id
            );
            this.$store.dispatch(
              "competitions/updateOmega",
              this.$route.params.competitions_id
            );

            this.changeLaneDialog = false;
            this.currentTeamDetails = {};
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later"
            });
          }
        });
    },
    resetMarshalling() {
      this.resetting = true;
      this.$store
        .dispatch("events/resetEventProgress", {
          section: "Marshalling",
          round: this.round.id,
          id: this.round.events_id
        })
        .then(result => {
          this.resetting = false;
          if (result.Result == "Success") {
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message
            });
            this.$store.dispatch(
              "eventProgress/loadCurrentRound",
              this.round.id
            );
            this.$store.dispatch(
              "competitions/updateOmega",
              this.$route.params.competitions_id
            );
            this.$store.dispatch(
              "eventProgress/loadRounds",
              this.$route.params.events_id
            );
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later"
            });
          }
        });
    },
    scratch(row) {
      row.scratched = row.scratched == 1 ? 0 : 1;
      row.status = 0;
      this.updateValue(row.id, 0);
      this.$store.dispatch("eventProgress/scratchMember", {
        id: row.participants_id,
        value: row.scratched,
        isTeamEvent: JSON.parse(this.event.playerLabels).length > 1
      });
    },

    // Start Scanner
    async handleNFCScan(message, serialNumber, extraData) {
      // ADD NFC to Member
      try {
        // Find Member Via NFC
        let NFCFound = false;

        // Team
        if (this.round.marshalled[0].team_name) {
          this.round.marshalled.forEach(team => {
            team.members.forEach(member => {
              member.NFCTags.forEach(tag => {
                if (tag.serialNumber == serialNumber) {
                  team.status = 1;
                  this.updateValue(team.id, 1);
                  NFCFound = true;
                  this.$q.notify({
                    position: "top-right",
                    type: "positive",
                    message: "Member Scanned Successfully"
                  });
                }
              });
            });
          });
        } else {
          // Individual
          this.round.marshalled.forEach(member => {
            member.NFCTags.forEach(tag => {
              if (tag.serialNumber == serialNumber) {
                member.status = 1;
                this.updateValue(member.id, 1);
                NFCFound = true;
                this.$q.notify({
                  position: "top-right",
                  type: "positive",
                  message: "Member Scanned Successfully"
                });
              }
            });
          });
        }

        if (!NFCFound) {
          this.$q.notify({
            position: "top-right",
            type: "negative",
            message: "Member Not Found"
          });
        }
      } catch (error) {
        console.log(error);
        this.$q.notify({
          position: "top-right",
          type: "negative",
          message: "There was an error, Please try again later"
        });
      }
    },
    startScanner() {
      this.$store.dispatch("NFC/startScanner", {
        $this: this,
        handleNFCScan: this.handleNFCScan
      });
    }
  }
};
</script>
